export const ChatSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="md:w-[328px] md:max-w-[328px] w-[calc(100vw-200px)] h-5 bg-background_white_overlay5 rounded-[4px] animate-pulse"></div>
      {Array.from({ length: 4 }, (_, index) => (
        <div
          key={index}
          className="w-full h-5 bg-background_white_overlay5 rounded-[4px] animate-pulse"
        ></div>
      ))}
      <div className="md:w-[614px] md:max-w-[614px] w-[calc(100vw-100px)] h-5 bg-background_white_overlay5 rounded-[4px] animate-pulse"></div>
    </div>
  );
};
